export const WHATSAPP_PROFILE_DESIGN = {
    shell: 'flex flex-col w-full bg-[#f4f4f7] text-[#18181b]',
    fontStack: "'Plus Jakarta Sans', Manrope, ui-sans-serif, system-ui, sans-serif",
    header: 'sticky top-0 z-30 bg-white border-b border-[#e7e7ec]',
    headerInner: 'w-full px-4 md:px-6 lg:px-8',
    topbar: 'flex flex-col md:flex-row md:items-start gap-4 pt-[18px] pb-[18px]',
    topbarIdentity: 'flex items-start gap-3.5 min-w-0 flex-1',
    backBtn: 'flex items-center justify-center flex-shrink-0 w-[34px] h-[34px] mt-[3px] rounded-lg text-[#71717a] transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b]',
    iconTile: 'flex items-center justify-center flex-shrink-0 w-[42px] h-[42px] rounded-[10px] bg-gradient-to-b from-emerald-50 to-emerald-100 text-emerald-600',
    title: 'text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b]',
    subtitle: 'mt-[5px] text-[13px] text-[#71717a] leading-[1.5]',
    actions: 'flex items-center gap-2 flex-shrink-0 flex-wrap md:pt-[5px]',
    actionOutline: 'inline-flex items-center justify-center gap-2 h-9 px-3.5 rounded-[10px] border border-[#d4d4d8] bg-white text-[#18181b] text-xs font-semibold hover:bg-[#f4f4f7] disabled:opacity-50',
    actionPrimary: 'inline-flex items-center justify-center gap-2 h-9 px-4 rounded-[10px] bg-gradient-to-b from-[#8b5cf6] to-[#7c3aed] text-white text-xs font-semibold shadow-[0_2px_8px_rgba(124,58,237,.32)] hover:from-[#7c3aed] hover:to-[#6d28d9] disabled:opacity-50 disabled:cursor-not-allowed',
    body: 'w-full px-4 md:px-6 lg:px-8 pt-5 pb-5',
    error: 'flex items-start gap-2.5 bg-red-50 border border-red-100 rounded-xl px-4 py-3 mb-5 text-[13px] text-red-700',
    loading: 'flex flex-col items-center justify-center py-20 gap-3 text-[#71717a]',
    grid: 'grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_320px] xl:grid-cols-[minmax(0,1fr)_360px] gap-5 items-start',
    stack: 'flex flex-col gap-4 min-w-0',
    card: 'bg-white rounded-xl border border-[#e7e7ec] p-5 shadow-[0_1px_2px_rgba(24,24,27,0.03)]',
    cardTitle: 'text-[14px] font-bold text-[#18181b] flex items-center gap-2.5 mb-4',
    cardIcon: 'w-8 h-8 rounded-lg bg-emerald-50 flex items-center justify-center text-emerald-600 shrink-0',
    identityRow: 'flex items-start gap-4',
    avatarWrap: 'relative shrink-0',
    avatar: 'w-20 h-20 rounded-2xl object-cover border border-[#e7e7ec] bg-[#fafafa]',
    avatarFallback: 'w-20 h-20 rounded-2xl bg-emerald-50 border border-emerald-100 flex items-center justify-center',
    changeBtn: 'absolute -bottom-1 -right-1 w-8 h-8 rounded-full bg-[#7C3AED] hover:bg-[#6d28d9] text-white flex items-center justify-center shadow-md ring-2 ring-white disabled:opacity-60',
    identityMeta: 'min-w-0 flex-1',
    identityName: 'text-lg font-bold text-[#18181b] truncate',
    identityPhone: 'text-sm font-semibold text-emerald-600 truncate mt-0.5',
    field: 'flex flex-col gap-1.5',
    fieldFull: 'flex flex-col gap-1.5 md:col-span-2',
    labelRow: 'flex items-center justify-between gap-2',
    label: 'text-[10px] font-bold uppercase tracking-[0.08em] text-[#a1a1aa]',
    counter: 'text-[10px] font-semibold text-[#a1a1aa] tabular-nums',
    input: 'w-full h-10 rounded-[10px] border border-[#e7e7ec] bg-white px-3 text-[13px] text-[#18181b] placeholder:text-[#a1a1aa] focus:outline-none focus:border-[#7C3AED] focus:ring-2 focus:ring-[#7C3AED]/20',
    inputReadonly: 'w-full h-10 rounded-[10px] border border-[#e7e7ec] bg-[#fafafa] px-3 text-[13px] text-[#52525b] cursor-not-allowed',
    textarea: 'w-full min-h-[80px] rounded-[10px] border border-[#e7e7ec] bg-white px-3 py-2.5 text-[13px] text-[#18181b] placeholder:text-[#a1a1aa] resize-y leading-relaxed focus:outline-none focus:border-[#7C3AED] focus:ring-2 focus:ring-[#7C3AED]/20',
    textareaSm: 'w-full min-h-[56px] rounded-[10px] border border-[#e7e7ec] bg-white px-3 py-2.5 text-[13px] text-[#18181b] placeholder:text-[#a1a1aa] resize-none leading-relaxed focus:outline-none focus:border-[#7C3AED] focus:ring-2 focus:ring-[#7C3AED]/20',
    select: 'w-full h-10 rounded-[10px] border border-[#e7e7ec] bg-white px-3 text-[13px] text-[#18181b] focus:outline-none focus:border-[#7C3AED] focus:ring-2 focus:ring-[#7C3AED]/20',
    formGrid: 'grid grid-cols-1 md:grid-cols-2 gap-4',
    identityFields: 'grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4',
    helpBox: 'flex gap-2.5 rounded-xl border border-amber-200 bg-amber-50 px-3.5 py-3 text-[12px] text-amber-900 leading-relaxed',
    previewCard: 'lg:sticky lg:top-[92px] rounded-2xl border border-[#e7e7ec] bg-white overflow-hidden shadow-[0_1px_3px_rgba(24,24,27,0.04)]',
    previewHeader: 'px-4 py-3 border-b border-[#f0f0f3] flex items-center gap-2 bg-[#008069] text-white',
    previewTitle: 'text-[13px] font-bold',
    previewBody: 'p-4 flex flex-col items-center text-center',
    previewAvatar: 'w-24 h-24 rounded-full object-cover border-4 border-white shadow-md bg-[#fafafa]',
    previewAvatarFallback: 'w-24 h-24 rounded-full bg-emerald-50 border-4 border-white shadow-md flex items-center justify-center',
    previewName: 'mt-4 text-base font-bold text-[#18181b]',
    previewAbout: 'mt-2 text-[13px] text-[#52525b] leading-relaxed whitespace-pre-wrap max-w-[280px]',
    previewDescription: 'mt-3 text-[12px] text-[#71717a] leading-relaxed whitespace-pre-wrap max-w-[280px]',
    previewBadge: 'mt-3 inline-flex items-center px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-700 text-[11px] font-semibold border border-emerald-100',
    previewMeta: 'mt-4 w-full space-y-2 text-left',
    previewMetaRow: 'flex items-start gap-2 text-[12px] text-[#52525b]',
    previewMetaIcon: 'text-emerald-600 shrink-0 mt-0.5',
    previewEmpty: 'text-[13px] text-[#a1a1aa] italic mt-2',
};

export const WHATSAPP_VERTICALS = [
    { value: 'OTHER' },
    { value: 'AUTO' },
    { value: 'BEAUTY' },
    { value: 'APPAREL' },
    { value: 'EDU' },
    { value: 'ENTERTAIN' },
    { value: 'EVENT_PLAN' },
    { value: 'FINANCE' },
    { value: 'GROCERY' },
    { value: 'GOVT' },
    { value: 'HOTEL' },
    { value: 'HEALTH' },
    { value: 'NONPROFIT' },
    { value: 'PROF_SERVICES' },
    { value: 'RETAIL' },
    { value: 'TRAVEL' },
    { value: 'RESTAURANT' },
    { value: 'ALCOHOL' },
    { value: 'ONLINE_GAMBLING' },
    { value: 'PHYSICAL_GAMBLING' },
    { value: 'OTC_DRUGS' },
];
